import HttpCliente from "../HttpCliente";

export const getCorreos = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/Correo/ObtenerCorreos", {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'text/plain'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const postCorreo = (token, correo) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post("/Correo/Crear", correo, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
        resolve(response.data);
        }).catch(error => {
        reject(error);
        });
    });
};

export const putCorreo = (token, correo) => {
  return new Promise((resolve, reject) => {
    HttpCliente.put("/Correo/EditarCorreo", correo, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        }
    }).then(response => {
        resolve(response.data);
        }).catch(error => {
        reject(error);
        });
    });
};

export const obtenerInfoClienteEnvioManual = (token, clienteId) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get(`/EnvioCorreo/info-cliente/${clienteId}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'application/json'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      console.error("Error al obtener info del cliente:", error.response?.data || error);
      reject(error.response?.data?.message || "Error al obtener información del cliente");
    });
  });
};

// Enviar correo manual
export const enviarCorreoManual = (token, data) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post('/EnvioCorreo/enviar', data, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      console.error("Error al enviar correo manual:", error.response?.data || error);
      reject(error.response?.data?.message || "Error al enviar correo manual");
    });
  });
};

// Generar vista previa de envío manual
export const generarVistaPreviaEnvioManual = (token, clienteId, mensajePersonalizado = null) => {
  return new Promise((resolve, reject) => {
    HttpCliente.post('/EnvioCorreo/vista-previa-manual', {
      clienteId: clienteId,
      mensajePersonalizado: mensajePersonalizado
    }, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      console.error("Error al generar vista previa manual:", error.response?.data || error);
      reject(error.response?.data || "Error al generar vista previa");
    });
  });
};